import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "bg-gray-200 rounded-sm px-1 py-0.5" }
const _hoisted_3 = {
  key: 1,
  class: "italic text-gray-500"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "space-y-4" }
const _hoisted_6 = {
  key: 0,
  class: "text-sm font-medium text-gray-500 italic"
}
const _hoisted_7 = { class: "text-sm font-medium text-gray-700 whitespace-normal" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["selected"]
const _hoisted_10 = ["selected"]
const _hoisted_11 = {
  key: 2,
  class: "space-y-4"
}
const _hoisted_12 = ["id", "checked", "name", "onChange"]
const _hoisted_13 = ["for"]
const _hoisted_14 = {
  key: 3,
  class: "space-y-4"
}
const _hoisted_15 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_16 = ["id", "checked", "name", "onChange"]
const _hoisted_17 = ["for"]
const _hoisted_18 = {
  key: 4,
  class: "space-y-4"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 5,
  class: "space-y-2"
}
const _hoisted_21 = {
  key: 0,
  disabled: "",
  selected: ""
}
const _hoisted_22 = ["selected", "value"]
const _hoisted_23 = {
  key: 0,
  disabled: "",
  selected: ""
}
const _hoisted_24 = ["selected", "value"]
const _hoisted_25 = { key: 6 }
const _hoisted_26 = {
  key: 0,
  disabled: "",
  selected: ""
}
const _hoisted_27 = ["selected", "value"]
const _hoisted_28 = { key: 8 }
const _hoisted_29 = {
  key: 9,
  class: "flex items-center gap-2"
}
const _hoisted_30 = { class: "flex-1 min-w-0" }
const _hoisted_31 = ["selected", "value"]
const _hoisted_32 = { key: 10 }
const _hoisted_33 = {
  key: 14,
  class: "space-y-2"
}
const _hoisted_34 = {
  key: 0,
  disabled: "",
  selected: ""
}
const _hoisted_35 = ["selected", "value"]
const _hoisted_36 = {
  key: 0,
  disabled: "",
  selected: ""
}
const _hoisted_37 = ["selected", "value"]

import { Popover, PopoverButton, PopoverGroup, PopoverPanel } from '@headlessui/vue'
import { MenuItem } from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/20/solid'
import { ulid } from 'ulid'
import { DatePicker } from 'v-calendar'
import { computed, onMounted, ref, watch } from 'vue'

import InputField from '@/components/neue/InputField'
import { useDropdownAnchor } from '@/composables/useDropdownAnchor'
import api from '@/store/api'


export default {
  __name: 'FilterDropdown',
  props: [
  'name',
  'activeName',
  'selectOptions',
  'currentSelectOption',
  'currentOperatorOption',
  'currentField',
  'currentUnit',
  'shape',
  'raw',
  'special',
  'reverseOptions',
  'reversed',
  'search',
  'endpointSelect'
],
  emits: [
  'updateSelect',
  'updateOperator',
  'updateField',
  'updateUnit',
  'updateSpecial',
  'updateReverse',
  'remove'
],
  setup(__props, { emit: __emit }) {

const id = ulid()
const props = __props
const emit = __emit

const { setReference, setFloating, floatingStyles } = useDropdownAnchor({ placement: 'bottom-start' })

const hasOperator = computed(() =>
  [
    'operator-date',
    'operator-date-time',
    'operator-relative-time',
    'operator-days-future',
    'operator-number',
    'operator-dollars',
    'special-changed-tier'
  ].includes(props.shape)
)

const timeUnitOptions = [
  { name: 'Days', value: 'days' },
  { name: 'Hours', value: 'hours' },
  { name: 'Minutes', value: 'minutes' }
]

const countOptions = [
  { name: 'equals', value: '==' },
  { name: 'does not equal', value: '!=' },
  { name: 'is greater than', value: '>' },
  { name: 'is greater than or equal to', value: '>=' },
  { name: 'is less than', value: '<' },
  { name: 'is less than or equal to', value: '<=' }
]

const dateOptions = [
  { name: 'on', value: '==' },
  { name: 'after', value: '>' },
  { name: 'on or after', value: '>=' },
  { name: 'before', value: '<' },
  { name: 'on or before', value: '<=' }
]

const datetimeOptions = [
  { name: 'after', value: '>' },
  { name: 'before', value: '<' }
]

const operatorOptions = computed(() => {
  if (props.shape === 'operator-date-time') return datetimeOptions
  // A sub-day amount is a to-the-second instant, so only after / before are
  // coherent ("on 3 hours ago" would be an exact-second match → empty list).
  // Days keep the full set so existing day-based filters still display fully.
  if (props.shape === 'operator-relative-time') {
    return (props.currentUnit || 'days') === 'days' ? dateOptions : datetimeOptions
  }
  if (
    props.shape === 'operator-date' ||
    props.shape === 'operator-days-future' ||
    props.shape === 'special-changed-tier'
  )
    return dateOptions
  return countOptions
})

const date = ref(props.currentField)
watch(date, () => {
  emit('updateField', date.value)
})

const searchQuery = ref('')
const searchResults = ref([])
const endpointOptions = ref([])
const loadingOptions = ref(false)

onMounted(() => {
  if (props.shape === 'select-from-endpoint' && props.endpointSelect) {
    loadEndpointOptions()
  }
})

const loadEndpointOptions = async () => {
  if (!props.endpointSelect?.endpoint) return

  loadingOptions.value = true
  try {
    const response = await api.call('GET', props.endpointSelect.endpoint)
    endpointOptions.value = response.data.data.map(item => ({
      id: item.id,
      name: props.endpointSelect.name(item)
    }))
  } catch (error) {
    console.error('Failed to load endpoint options:', error)
    endpointOptions.value = []
  } finally {
    loadingOptions.value = false
  }
}

return (_ctx, _cache) => {
  const _component_InlineSearchSelect = _resolveComponent("InlineSearchSelect")
  const _component_NeueButton = _resolveComponent("NeueButton")

  return (_openBlock(), _createBlock(_unref(PopoverGroup), { class: "flex items-baseline space-x-8" }, {
    default: _withCtx(() => [
      _createVNode(_unref(Popover), {
        as: "div",
        class: "relative inline-block text-left"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_unref(PopoverButton), {
              ref: _unref(setReference),
              class: "group inline-flex items-center justify-center text-sm rounded-full bg-gray-50 py-1 pl-2.5 pr-2 font-medium tabular-nums text-gray-600 border border-gray-400"
            }, {
              default: _withCtx(() => [
                (props.activeName?.[1])
                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                      _createElementVNode("span", null, _toDisplayString(props.activeName[0]), 1),
                      _createElementVNode("span", _hoisted_2, _toDisplayString(props.activeName[1]), 1)
                    ]))
                  : (props.raw)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Unknown filter"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(props.name), 1)),
                _createVNode(_unref(ChevronDownIcon), {
                  class: "-mr-1 ml-1 h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-gray-500",
                  "aria-hidden": "true"
                })
              ]),
              _: 1
            }, 512)
          ]),
          (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
            _createVNode(_Transition, {
              "enter-active-class": "transition ease-out duration-100",
              "enter-from-class": "transform opacity-0 scale-95",
              "enter-to-class": "transform opacity-100 scale-100",
              "leave-active-class": "transition ease-in duration-75",
              "leave-from-class": "transform opacity-100 scale-100",
              "leave-to-class": "transform opacity-0 scale-95"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(PopoverPanel), {
                  ref: _unref(setFloating),
                  style: _normalizeStyle(_unref(floatingStyles)),
                  class: "z-50 w-72 overflow-y-auto rounded-md bg-white p-4 shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("fieldset", _hoisted_5, [
                      (props.raw)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(props.raw.attributes.type), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(props.name), 1),
                      (props.reverseOptions)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("select", {
                              class: "block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-gray-500 focus:outline-none focus:ring-gray-500 sm:text-sm",
                              onChange: _cache[0] || (_cache[0] = e => emit('updateReverse', e.target.value === 'true'))
                            }, [
                              _createElementVNode("option", {
                                selected: !props.reversed,
                                value: "false"
                              }, _toDisplayString(props.reverseOptions[false]), 9, _hoisted_9),
                              _createElementVNode("option", {
                                selected: props.reversed,
                                value: "true"
                              }, _toDisplayString(props.reverseOptions[true]), 9, _hoisted_10)
                            ], 32)
                          ]))
                        : _createCommentVNode("", true),
                      (props.shape === 'select')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.selectOptions, (option) => {
                              return (_openBlock(), _createBlock(_unref(PopoverButton), { class: "flex items-center" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("input", {
                                    id: _unref(id) + option.id,
                                    checked: props.currentSelectOption === option.id,
                                    name: _unref(id),
                                    type: "radio",
                                    class: "h-4 w-4 border-gray-300 text-brand-600 focus:ring-brand-500 cursor-pointer",
                                    onChange: $event => (emit('updateSelect', option.id))
                                  }, null, 40, _hoisted_12),
                                  _createElementVNode("label", {
                                    for: _unref(id) + option.id,
                                    class: "ml-3 text-left whitespace-normal pr-6 text-sm font-medium text-gray-900 cursor-pointer"
                                  }, _toDisplayString(option.name), 9, _hoisted_13)
                                ]),
                                _: 2
                              }, 1024))
                            }), 256))
                          ]))
                        : _createCommentVNode("", true),
                      (props.shape === 'select-from-endpoint')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            (loadingOptions.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, "Loading options..."))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(endpointOptions.value, (option) => {
                              return (_openBlock(), _createBlock(_unref(PopoverButton), {
                                key: option.id,
                                class: "flex items-center"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("input", {
                                    id: _unref(id) + option.id,
                                    checked: props.currentSelectOption === option.id,
                                    name: _unref(id),
                                    type: "radio",
                                    class: "h-4 w-4 border-gray-300 text-brand-600 focus:ring-brand-500 cursor-pointer",
                                    onChange: $event => (emit('updateSelect', option.id))
                                  }, null, 40, _hoisted_16),
                                  _createElementVNode("label", {
                                    for: _unref(id) + option.id,
                                    class: "ml-3 text-left whitespace-normal pr-6 text-sm font-medium text-gray-900 cursor-pointer"
                                  }, _toDisplayString(option.name), 9, _hoisted_17)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (props.shape === 'search')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createVNode(_component_InlineSearchSelect, {
                              "helper-text": {
                    typingPrompt: `Search for ${props.search.plural}...`,
                    noResult: `No ${props.search.plural} found`
                  },
                              "search-endpoint": `${props.search.endpoint}/search?included=none`,
                              "search-request": { search: { text: searchQuery.value } },
                              onOnSearch: _cache[1] || (_cache[1] = x => (searchQuery.value = x)),
                              onOnResults: _cache[2] || (_cache[2] = x => (searchResults.value = x))
                            }, {
                              searchResults: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResults.value, (item) => {
                                  return (_openBlock(), _createBlock(_unref(PopoverButton), {
                                    key: item.id,
                                    class: "flex text-wrap w-full"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("button", {
                                        class: "rounded-md w-full px-2 py-2 text-sm text-left hover:bg-gray-100 duration-200 transition-colors text-gray-700",
                                        onClick: $event => (emit('updateSelect', item.id))
                                      }, _toDisplayString(props.search.name(item)), 9, _hoisted_19)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["helper-text", "search-endpoint", "search-request"])
                          ]))
                        : _createCommentVNode("", true),
                      (props.shape === 'special-changed-tier')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createElementVNode("div", null, [
                              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "text-sm font-medium text-gray-700 mb-1" }, "from", -1)),
                              _createElementVNode("select", {
                                class: "block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-gray-500 focus:outline-none focus:ring-gray-500 sm:text-sm",
                                onChange: _cache[3] || (_cache[3] = e => emit('updateSpecial', { ...props.special, from: e.target.value }))
                              }, [
                                (!props.special.from)
                                  ? (_openBlock(), _createElementBlock("option", _hoisted_21))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.selectOptions, (option) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    selected: props.special.from === option.id,
                                    value: option.id
                                  }, _toDisplayString(option.name), 9, _hoisted_22))
                                }), 256))
                              ], 32)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "text-sm font-medium text-gray-700 mb-1" }, "to", -1)),
                              _createElementVNode("select", {
                                class: "block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-gray-500 focus:outline-none focus:ring-gray-500 sm:text-sm",
                                onChange: _cache[4] || (_cache[4] = e => emit('updateSpecial', { ...props.special, to: e.target.value }))
                              }, [
                                (!props.special.to)
                                  ? (_openBlock(), _createElementBlock("option", _hoisted_23))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.selectOptions, (option) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    selected: props.special.to === option.id,
                                    value: option.id
                                  }, _toDisplayString(option.name), 9, _hoisted_24))
                                }), 256))
                              ], 32)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (hasOperator.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createElementVNode("select", {
                              class: "block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-gray-500 focus:outline-none focus:ring-gray-500 sm:text-sm",
                              onChange: _cache[5] || (_cache[5] = e => emit('updateOperator', e.target.value))
                            }, [
                              (!props.currentOperatorOption)
                                ? (_openBlock(), _createElementBlock("option", _hoisted_26))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(operatorOptions.value, (option) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  selected: props.currentOperatorOption === option.value,
                                  value: option.value
                                }, _toDisplayString(option.name), 9, _hoisted_27))
                              }), 256))
                            ], 32)
                          ]))
                        : _createCommentVNode("", true),
                      (props.shape === 'operator-number' || props.shape === 'string')
                        ? (_openBlock(), _createBlock(_unref(InputField), {
                            key: 7,
                            "model-value": props.currentField,
                            onChange: _cache[6] || (_cache[6] = e => emit('updateField', e.target.value))
                          }, null, 8, ["model-value"]))
                        : _createCommentVNode("", true),
                      (props.shape === 'special-changed-tier')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createVNode(_unref(InputField), {
                              "model-value": props.currentField,
                              onChange: _cache[7] || (_cache[7] = e => emit('updateField', e.target.value))
                            }, null, 8, ["model-value"]),
                            _cache[21] || (_cache[21] = _createElementVNode("div", { class: "text-sm font-medium text-gray-700 mt-1" }, "days ago", -1))
                          ]))
                        : _createCommentVNode("", true),
                      (props.shape === 'operator-relative-time')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                              _createVNode(_unref(InputField), {
                                "model-value": props.currentField,
                                onChange: _cache[8] || (_cache[8] = e => emit('updateField', e.target.value))
                              }, null, 8, ["model-value"])
                            ]),
                            _createElementVNode("select", {
                              class: "rounded-md border-gray-300 py-2 pl-3 pr-8 text-base focus:border-gray-500 focus:outline-none focus:ring-gray-500 sm:text-sm",
                              onChange: _cache[9] || (_cache[9] = e => emit('updateUnit', e.target.value))
                            }, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(timeUnitOptions, (option) => {
                                return _createElementVNode("option", {
                                  key: option.value,
                                  selected: (props.currentUnit || 'days') === option.value,
                                  value: option.value
                                }, _toDisplayString(option.name), 9, _hoisted_31)
                              }), 64))
                            ], 32),
                            _cache[22] || (_cache[22] = _createElementVNode("span", { class: "text-sm font-medium text-gray-700" }, "ago", -1))
                          ]))
                        : _createCommentVNode("", true),
                      (props.shape === 'operator-days-future')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            _createVNode(_unref(InputField), {
                              "model-value": props.currentField,
                              onChange: _cache[10] || (_cache[10] = e => emit('updateField', e.target.value))
                            }, null, 8, ["model-value"]),
                            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "text-sm font-medium text-gray-700 mt-1" }, "days from now", -1))
                          ]))
                        : _createCommentVNode("", true),
                      (props.shape === 'operator-dollars')
                        ? (_openBlock(), _createBlock(_unref(InputField), {
                            key: 11,
                            "model-value": props.currentField,
                            prefix: "$",
                            onChange: _cache[11] || (_cache[11] = e => emit('updateField', e.target.value))
                          }, null, 8, ["model-value"]))
                        : _createCommentVNode("", true),
                      (props.shape === 'operator-date' || props.shape === 'date')
                        ? (_openBlock(), _createBlock(_unref(DatePicker), {
                            key: 12,
                            modelValue: date.value,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((date).value = $event)),
                            mode: "date",
                            "is-required": true
                          }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true),
                      (props.shape === 'operator-date-time')
                        ? (_openBlock(), _createBlock(_unref(DatePicker), {
                            key: 13,
                            modelValue: date.value,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((date).value = $event)),
                            mode: "datetime",
                            "is-required": true
                          }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true),
                      (props.shape === 'special-order-count')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            _createElementVNode("select", {
                              class: "block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-gray-500 focus:outline-none focus:ring-gray-500 sm:text-sm",
                              onChange: _cache[14] || (_cache[14] = e => emit('updateSpecial', { ...props.special, operatorCount: e.target.value }))
                            }, [
                              (!props.special.operatorCount)
                                ? (_openBlock(), _createElementBlock("option", _hoisted_34))
                                : _createCommentVNode("", true),
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(countOptions, (option) => {
                                return _createElementVNode("option", {
                                  selected: props.special.operatorCount === option.value,
                                  value: option.value
                                }, _toDisplayString(option.name), 9, _hoisted_35)
                              }), 64))
                            ], 32),
                            _createVNode(_unref(InputField), {
                              "model-value": props.special.fieldCount,
                              onChange: _cache[15] || (_cache[15] = e => emit('updateSpecial', { ...props.special, fieldCount: e.target.value }))
                            }, null, 8, ["model-value"]),
                            _createElementVNode("select", {
                              class: "block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-gray-500 focus:outline-none focus:ring-gray-500 sm:text-sm",
                              onChange: _cache[16] || (_cache[16] = e => emit('updateSpecial', { ...props.special, operatorDays: e.target.value }))
                            }, [
                              (!props.special.operatorDays)
                                ? (_openBlock(), _createElementBlock("option", _hoisted_36))
                                : _createCommentVNode("", true),
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(dateOptions, (option) => {
                                return _createElementVNode("option", {
                                  selected: props.special.operatorDays === option.value,
                                  value: option.value
                                }, _toDisplayString(option.name), 9, _hoisted_37)
                              }), 64))
                            ], 32),
                            _createVNode(_unref(InputField), {
                              "model-value": props.special.fieldDays,
                              onChange: _cache[17] || (_cache[17] = e => emit('updateSpecial', { ...props.special, fieldDays: e.target.value }))
                            }, null, 8, ["model-value"]),
                            _cache[24] || (_cache[24] = _createElementVNode("div", { class: "text-sm font-medium text-gray-700 mt-1" }, "days ago", -1))
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_unref(PopoverButton), { class: "flex justify-between w-full" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_NeueButton, {
                            class: "bg-red-500 hover:bg-red-700 text-xs px-2 pt-1 pb-1",
                            onClick: _cache[18] || (_cache[18] = $event => (emit('remove')))
                          }, {
                            default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                              _createTextVNode(" Remove filter ", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_NeueButton, { class: "text-xs px-2 pt-1 pb-1 ml-4" }, {
                            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                              _createTextVNode("Save", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["style"])
              ]),
              _: 1
            })
          ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

}